"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileNav = exports.Nav = exports.openNav = void 0;
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const styled_components_1 = __importDefault(require("styled-components"));
const authProvider_1 = require("../authProvider/authProvider");
const origyn_art_ui_1 = require("@origyn/origyn-art-ui");
exports.openNav = [
    {
        path: '/',
        label: 'Home',
    },
    {
        path: '/explorer',
        label: 'Explorer',
    }
];
const authNav = [
    {
        path: '/proposals',
        label: 'Proposals',
    },
    {
        path: '/stakes',
        label: 'My Account',
    },
];
const Nav = () => {
    const params = (0, react_router_dom_1.useParams)();
    const [navItems, setNavItems] = (0, react_1.useState)(exports.openNav);
    const { loggedIn, principal } = (0, react_1.useContext)(authProvider_1.AuthContext);
    (0, react_1.useEffect)(() => {
        if (loggedIn) {
            setNavItems([...exports.openNav, ...authNav]);
        }
        else {
            setNavItems(exports.openNav);
        }
    }, [loggedIn]);
    return (react_1.default.createElement(CustomNav, null, navItems.map((e, i) => {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(NavLinkStyle, { key: e.path, to: `${e.path}` }, e.label)));
    })));
};
exports.Nav = Nav;
const MobileNav = ({ setDarktheme, theme }) => {
    const [open, setOpen] = (0, react_1.useState)(false);
    const [navItems, setNavItems] = (0, react_1.useState)(exports.openNav);
    const { loggedIn, principal } = (0, react_1.useContext)(authProvider_1.AuthContext);
    const handleMenuOpen = () => {
        document.getElementsByTagName("body")[0].style.overflow = open ? "auto" : "hidden";
        setOpen(!open);
    };
    (0, react_1.useEffect)(() => {
        if (loggedIn) {
            setNavItems([...exports.openNav, ...authNav]);
        }
        else {
            setNavItems(exports.openNav);
        }
    }, [loggedIn]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        open ? (react_1.default.createElement(origyn_art_ui_1.Button, { iconButton: true, textButton: true, size: 'small', onClick: handleMenuOpen },
            react_1.default.createElement(origyn_art_ui_1.Icons.CloseIcon, null))) : (react_1.default.createElement(origyn_art_ui_1.Button, { iconButton: true, textButton: true, size: 'small', onClick: handleMenuOpen },
            react_1.default.createElement(origyn_art_ui_1.Icons.MenuIcon, null))),
        open && (react_1.default.createElement(MobileMenu, null, navItems.map((e, i) => {
            return (react_1.default.createElement(NavLinkStyle, { key: e.path, to: `${e.path}`, onClick: handleMenuOpen }, e.label));
        })))));
};
exports.MobileNav = MobileNav;
const MobileMenu = styled_components_1.default.div `
  position: fixed;
  left: 0;
  top: 84px;
  height: calc(100vh - 84px);
  width: 100%;
  background: ${({ theme }) => theme.colors.BACKGROUND};
  padding: 48px;
  align-items: center;
  z-index: 999999;
  display: flex;
  flex-flow: column;
`;
const CustomNav = (0, styled_components_1.default)('nav') `
  display: flex;
  gap: 32px;
  flex-grow: 1;
  height: 100%;
`;
const NavLinkStyle = (0, styled_components_1.default)(react_router_dom_1.NavLink) `
  letter-spacing: -0.15px;
  font-weight: 600;
  font-size: 14px;
  line-height: 22px;
  color: ${({ theme }) => theme?.colors?.TEXT};
  border-bottom: 2px solid transparent;
  height: 100%;
  display: flex;
  align-items: center;

  &.active, &:hover {
    border-bottom: 2px solid ${({ theme }) => theme?.colors?.TEXT};
  }
`;
